// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3AMwE","selects":"Documents_selects__3ueaD"};